// @ts-nocheck
 
 
 
 
 
/* eslint-disable import/order */
 
 
 
/* eslint-disable react/jsx-newline */
 
 
 
 
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';
import  MerchantsTable  from 'app/cards-management/merchants/merchantsTable';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';
import AddMerchant from './addMerchant';
import EditMerchant from './updateMerchant';
import ViewMerchant from './view-merchant';

const Merchants: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasMerchantsAddAccess = useTypedSelector(state =>
    hasWriteAccessToMasterConfigSubSystem(state, 'Merchants')
  );

  return (
    <CardContainer>
      <Switch>
        <Route path={`${baseURL}/new`}>
          {hasMerchantsAddAccess ? <AddMerchant /> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id/edit`}>
        {hasMerchantsAddAccess ? <EditMerchant/> : <NotAuthorized />}
        </Route>
        <Route path={`${baseURL}/:id`}>
         <ViewMerchant/>
        </Route>
        <Route exact path={`${baseURL}`}>
          <MerchantsTable/>
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { Merchants };
